import { Component, OnInit} from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';

import { ModalChildComponent } from '@finder/shared/components/modal/modal-child-component.interface';
import { ModalComponent } from '@finder/shared/components/modal/modal.component';
import { CalendarsService } from '@finder/features/calendars/services/calendars.service';
import { CommonModule } from '@angular/common';
import { CalendarComponent } from '@finder/shared/components/calendar/calendar.component';
import { ButtonComponent } from '@finder/shared/components/button/button.component';

@Component({
    selector: 'finder-date-picker-modal',
    templateUrl: './date-picker-modal.component.html',
    styleUrls: ['./date-picker-modal.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        CalendarComponent,
        ButtonComponent,
    ]
})
export class DatePickerModalComponent implements ModalChildComponent, OnInit {

    parentComponent: ModalComponent;
    data: any;

    selectedDate: Date = new Date();

    private destroy$ = new Subject<void>();

    constructor(
        private calendarsService: CalendarsService,
    ) { }

    ngOnInit() {
        this.calendarsService.watchLocations()
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.selectedDate = this.calendarsService.selectedDate;
            });
    }

    onDateChanged(date) {
        this.selectedDate = date;
        this.calendarsService.emitDate(date);
    }

    dismiss() {
        this.parentComponent.dismiss();
    }
}
